module.exports = "<div class=\"switching-stage {{theme | themeClass}}\"> <div class=switching-container> <div v-for=\"item in switchNum\" class=switching-ele :class=\"{ hide: $index !== currentIndex }\"></div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/base/switching/switching.tpl
// module id = 946
// module chunks = 2